// eslint-disable class-methods-use-this
import { customElement } from 'lit/decorators.js';
import { connect } from 'pwa-helpers/connect-mixin.js';
import { TefComsCustomerAttributeBase } from '@common/customerAttributes/TefComsCustomerAttributeBase.js';
import { CustomerAttribute } from '@common/customerAttributes/types.js';
import { TemplatingMixin } from '@common/lit/mixins/TemplatingMixin.js';
import { Theme } from '@common/types/enum.js';
import { ReplaceElementsMixin } from '@src/components/mixins/ReplaceElementsMixin.js';
import { templates } from '@src/components/templates/index.js';
import { setCustomerAttribute } from '@src/store/consents.js';
import { store } from '@src/store/index.js';

const CompositeClass = ReplaceElementsMixin(
  TemplatingMixin(connect(store)(TefComsCustomerAttributeBase), Theme.OCCL, templates),
);

@customElement('tef-coms-customer-attribute')
export class TefComsCustomerAttribute extends CompositeClass {
  connectedCallback() {
    super.connectedCallback();
    // Only available here after store init and not on top of the class :(
    this.setTemplatingTheme(this.theme);
  }

  get customerAttributes() {
    const { consents: { customerAttributes } } = store.getState();
    return customerAttributes!;
  }

  get theme() {
    const { config: { occluri } } = store.getState();
    return occluri ? Theme.OCCL : Theme.TEFONE;
  }

  get userIsInRegisterFlow() {
    const { config: { registerToken, newcustomer } } = store.getState();
    //             LEGACY           RAITT
    return Boolean(registerToken || newcustomer);
  }

  get userIsInEditMode() {
    const { config: { mode }, consents } = store.getState();
    if (mode!.includes('multiedit') && consents.editmodeActiveGroupInd === -1) {
      return false;
    }
    return true;
  }

  saveCustomerAttributeToStore(customerAttribute: CustomerAttribute): void {
    store.dispatch(setCustomerAttribute(customerAttribute));
  }

  getTemplateFnFor(templateName: string) {
    return this.getTemplateFn(templateName);
  }

  get mainComponentTag() {
    return 'tef-coms';
  }
}
